import Task from './Task';
import { createError } from '../error';


class PositionUpdateTimesTask extends Task {
  constructor(
    $q,
    APIService,
    LogService,
    DataSyncService,
    PositionService,
    DateTimeService
  ) {
    super();
    this.$q = $q;
    this.APIService = APIService;
    this.LogService = LogService;
    this.DataSyncService = DataSyncService;
    this.PositionService = PositionService;
    this.DateTimeService = DateTimeService;

    this._positionId = null;
    this._startDateTime = null;
    this._endDateTime = null;
  }

  get canExecute() {
    return this.APIService.isOnline;
  }

  set positionId(id) {
    this._positionId = id;
  }

  get positionId() {
    return this._positionId;
  }

  set startDateTime(date) {
    this._startDateTime = date;
  }

  get startDateTime() {
    return this._startDateTime;
  }


  set endDateTime(date) {
    this._endDateTime = date;
  }

  get endDateTime() {
    return this._endDateTime;
  }

  populate(data) {
    this.startDateTime = new Date(data.startDateTime);
    this.endDateTime = new Date(data.endDateTime);
    this.positionId = data.positionId;
  }

  serialize(){
    return {
      startDateTime: this.startDateTime.toJSON(),
      endDateTime: this.endDateTime.toJSON(),
      positionId: this.positionId,
    };
  }

  execute() {
    return this.PositionService.updateTimesForPositionId(this.positionId, this.startDateTime, this.endDateTime);
  }
}

export default PositionUpdateTimesTask;
